module.exports = __webpack_public_path__ + "media/images/d_identify_comparables-1ef9c6b5bf96902bb78bf68b5d6b2046.svg";